import axios from 'axios'
import { ATUALIZAR_PESSOA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function atualizarPessoa (pessoa) {
  const url = `${URL}/pessoas/atualizar`;
  return dispatch => axios.post(url, pessoa, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ATUALIZAR_PESSOA,
        payload: response
      })
  );
}